export const GET_CONFIG = 'GET_CONFIG'
export const GET_TAGS = 'GET_TAGS'